"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CfgCurrencyListEn = /** @class */ (function () {
    function CfgCurrencyListEn() {
    }
    CfgCurrencyListEn.getLangData = function () {
        return {
            document_title: "Currencies",
            editor: {
                breadcrumb: {
                    new_currency: ["Currency creation"],
                    edit_currency: ["Currency editing"]
                },
                message: {
                    currency_added: "Currency added!",
                    currency_changed: "Currency changed!"
                },
                error: {
                    field_title_empty: "Field [name] is empty!",
                    field_iso_empty: "Field [iso] is empty!",
                    field_symbol_empty: "Field [symbol] is empty!",
                    field_rate_empty: "Field [rate] is empty!"
                },
                title: {
                    new_currency: "Add currency:",
                    edit_currency: "Change currency",
                },
                fields: {
                    title: {
                        caption: "Title:",
                        placeholder: "Enter the title",
                    },
                    iso: {
                        caption: "ISO:",
                        placeholder: "Enter the iso",
                    },
                    symbol: {
                        caption: "Symbol:",
                        placeholder: "Enter the symbol"
                    },
                    exchange_rate: {
                        caption: "Exchange rate:",
                        placeholder: "Enter exchange rate"
                    }
                },
                checkboxes: {
                    is_deprecated: "Currency deprecated",
                    is_fun: "Fun currency"
                },
                buttons: {
                    save: "Save",
                    create: "Create",
                    back: "Back",
                }
            },
            list: {
                message: {
                    set_as_actual_fmt: "Currency {0} marked as actual",
                    set_as_deprecated_fmt: "Currency {0} marked as deprecated",
                    currency_deleted_fmt: "Currency {0} has been successfully deleted",
                    currency_imported_fmt: "Currencies are imported. Added: {0}. Updated: {1}!",
                    currency_loaded: "Currencies was loaded from the server!",
                    set_all_currency_is_deprecated: "All currencies are marked as deprecated!",
                    set_all_currency_is_actual: "All currencies are marked as actual!"
                },
                rows: {
                    title: "Title",
                    iso: "ISO",
                    symbol: "Symbol",
                    exchange_rate: "Rate",
                    is_base: {
                        title: "Base",
                        view: {
                            no: "No",
                            yes: "Yes",
                        },
                        filter: {
                            base: "Base",
                            derivative: "Derivative"
                        }
                    },
                    is_fun: {
                        title: "Fun currency",
                        view: {
                            no: "No",
                            yes: "Yes",
                        },
                        filter: {
                            demo: "Fun",
                            money: "Real",
                        }
                    },
                    is_actual: {
                        title: "Actual",
                        menu: {
                            actual: {
                                menu: "Mark as actual",
                                text: "Да"
                            },
                            deprecate: {
                                menu: "Mark as deprecated",
                                text: "No",
                            }
                        },
                        filter: {
                            actual: "Actual",
                            deprecate: "Deprecated",
                        }
                    },
                    updated: "Changed",
                    action: {
                        title: "Actions",
                        edit: "Edit",
                        delete: {
                            hint: "Delete",
                            confirm: "Delete this record ?",
                        }
                    }
                },
                toolbars: {
                    hints: {
                        create: "Create",
                        refresh: "Update",
                    },
                    import_all: {
                        confirm_title: "Import currencies ?",
                        ok_text: "Yes",
                        cancel_text: "No",
                        button_hint: "Import currencies"
                    },
                    lock_all: {
                        confirm_title: "Set all currencies as deprecated?",
                        ok_text: "yes",
                        cancel_text: "No",
                        button_hint: "Set all currencies as deprecated"
                    },
                    unlock_all: {
                        confirm_title: "Set all currencies as actual?",
                        ok_text: "Да",
                        cancel_text: "Нет",
                        button_hint: "Set all currencies as actual"
                    }
                },
                footer: {
                    title_fmt: "Displayed on page: {0} records",
                },
                details: {
                    created: "Created:",
                    changed: "Changed:",
                }
            }
        };
    };
    return CfgCurrencyListEn;
}());
exports.CfgCurrencyListEn = CfgCurrencyListEn;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cfg_currency/ui/lang/CfgCurrencyListEn.ts
// module id = 2042
// module chunks = 0